module.exports = __webpack_public_path__ + "img/gb-whatsapp-guide.70025631.webp";